export default __webpack_public_path__ + "static/media/material.245ffacd.svg";